import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';
import { miniSerializeErrorOverride } from './serialize-error';
import logger from 'src/logger';
import { getSessionIdentifier } from 'src/helpers/session.helpers';
import { TPartnerInfo } from 'src/types/partner-info.type';
import { getPartnerInfo } from 'src/services/partner-info/partner-info.service';

// Initial state for the partner info slice
const initialState: TPartnerInfo = {
  partnerState: null,
};

// Create the slice
const partnerSlice = createSlice({
  name: 'partnerInfo',
  initialState,
  reducers: {
    setPartnerInfoData: (state, action: PayloadAction<any>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setPartnerInfoData } = partnerSlice.actions;

// Thunk to fetch the partner info and dispatch the whole response
export const getPartnerInfoAction = createAsyncThunk<void, void, { state: RootState }>(
  'partnerInfo/getPartnerInfo',
  async (_, { dispatch, getState }) => {
    const { session, partnerInfo } = getState() as RootState;

    if (!session) {
      throw new Error('Session not found');
    }

    // Check if partnerInfo data already exists in store
    if (partnerInfo.partnerState !== null) {
      // Data already exists, so do not make the API call
      return;
    }

    try {
      const response = await getPartnerInfo(getSessionIdentifier(session));

      dispatch(setPartnerInfoData(response));
    } catch (error) {
      logger.reportError(error, { message: 'Error in getPartnerInfoAction' });
      throw error;
    }
  },
  {
    serializeError: miniSerializeErrorOverride,
  },
);

// Selector to get the partnerState from the partnerInfo slice
export const selectPartnerState = (state: RootState) => state.partnerInfo.partnerState;

export default partnerSlice.reducer;
